export const ANNOUNCEMENT_BANNER_DISMISSED_KEY =
  'adminAnnouncementBannerDashboardDismissed'

export const ANNOUNCEMENT_BANNER_COLORS = {
  green: {
    background: '#e8f7f0',
    border: '#17b471',
    title: '#0b8f59',
  },
  yellow: {
    background: '#fff8e1',
    border: '#f6c343',
    title: '#8a6500',
  },
  red: {
    background: '#fdeaea',
    border: '#d93025',
    title: '#c5221f',
  },
}

export const normalizeAnnouncementBannerColor = color => {
  const colorMap = {
    success: 'green',
    warning: 'yellow',
    error: 'red',
    danger: 'red',
  }

  return colorMap[color] || color || 'green'
}

export const formatAnnouncementBannerDate = value => {
  if (!value) {
    return ''
  }

  return String(value).slice(0, 10)
}

export const normalizeAnnouncementBanner = announcementBanner => {
  if (!announcementBanner) {
    return null
  }

  return {
    active: Boolean(announcementBanner.active),
    startDate: formatAnnouncementBannerDate(announcementBanner.startDate),
    endDate: formatAnnouncementBannerDate(announcementBanner.endDate),
    title: announcementBanner.title || '',
    message: announcementBanner.message || '',
    color: normalizeAnnouncementBannerColor(announcementBanner.color),
  }
}

export const isAnnouncementBannerActive = announcementBanner => {
  const normalizedBanner = normalizeAnnouncementBanner(announcementBanner)

  if (!normalizedBanner || !normalizedBanner.active) {
    return false
  }

  if (!normalizedBanner.title && !normalizedBanner.message) {
    return false
  }

  return true
}

export const getAnnouncementBannerSessionValue = announcementBanner => {
  const normalizedBanner = normalizeAnnouncementBanner(announcementBanner)

  if (!normalizedBanner) {
    return ''
  }

  return [
    normalizedBanner.active,
    normalizedBanner.startDate,
    normalizedBanner.endDate,
    normalizedBanner.title,
    normalizedBanner.message,
    normalizedBanner.color,
  ].join('|')
}